import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';
import axios from 'axios';

export const requestReset = async form => {
    console.log('SET TIME OUT');
    try {
        dispatcher.dispatch({ type: actionConstants.FORGOT_PASSWORD });
        const resp = await Api.forgotPassword(form);
        dispatcher.dispatch({
            type: actionConstants.FORGOT_PASSWORD_SUCCESS,
            payload: resp
        });
    } catch (error) {
        console.error(error);
        dispatcher.dispatch({
            type: actionConstants.FORGOT_PASSWORD_FAILURE,
            payload: error
        });
    }

    // setTimeout(() => {
    //     console.log('TIME OUT EXECUTED');

    // }, 1000);

    //dispatcher.dispatch({type: action.LOGGED_IN});
};



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/forgot-password/ForgotPasswordActions.js